import { render, staticRenderFns } from "./applicant-profile.vue?vue&type=template&id=12d8c6c3"
import script from "./applicant-profile.vue?vue&type=script&lang=js"
export * from "./applicant-profile.vue?vue&type=script&lang=js"
import style0 from "./applicant-profile.vue?vue&type=style&index=0&id=12d8c6c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports